import { Container, makeStyles, useMediaQuery } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useErrorStore from '../hooks/useErrorStore';
import useSuccessStore from '../hooks/useSuccessStore';
import { WORKER_ROUTE_DEFINITIONS } from './workerRoutes';
import Footer from '../layout/Footer';
import Breakpoint from '../layout/mediaQuery';
import FooterMobile from '../layout/navigation/footerMobile/FooterMobile';
import Navigation from '../layout/navigation/Navigation';
import NavigationTopMobile from '../layout/navigation/NavigationTopMobile';
import ErrorToast from '../layout/toast/ErrorToast';
import SuccessToast from '../layout/toast/SuccessToast';

const containerStyle = (isTabletOrLarger) =>
  makeStyles({
    root: {
      marginLeft: isTabletOrLarger ? '0' : 'auto',
      paddingLeft: isTabletOrLarger ? '0' : '0.625rem',
      paddingRight: isTabletOrLarger ? '0' : '0.625rem',
      padding: 0,
      marginBottom: '48px',
      display: 'flex',
      flexDirection: 'column',
    },
  });

const WorkerLayoutPage = ({ children }) => {
  const { t } = useTranslation();
  const isTabletOrLarger = useMediaQuery(Breakpoint.tablet);
  const [{ errorMessage }, errorsActions] = useErrorStore();
  const [{ successMessage }, successAction] = useSuccessStore();

  const menuOptions = useMemo(() => [WORKER_ROUTE_DEFINITIONS.laborAvailability].map((route) => ({ ...route, label: t(route.i18nKey) })), [t]);

  return (
    <>
      {isTabletOrLarger ? <Navigation options={menuOptions} /> : <NavigationTopMobile />}
      <div className={`flex flex-grow ${isTabletOrLarger ? 'pl-14 pr-14' : 'pt-14'}`}>
        <Container classes={containerStyle(isTabletOrLarger)()} maxWidth={false}>
          {children}
        </Container>
        {!isTabletOrLarger ? <FooterMobile options={menuOptions} rotate /> : <Footer />}
      </div>
      <ErrorToast message={errorMessage} onClose={errorsActions.removeErrorMessage} />
      <SuccessToast message={successMessage} onClose={successAction.removeSuccessMessage} />
    </>
  );
};

WorkerLayoutPage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};

export default WorkerLayoutPage;
